import styled from 'styled-components';
import { Pagination, Row } from 'antd';

import { ArrowSlimIcon, ArrowSlimLeftIcon, ArrowSlimRightIcon } from '@/assets/icons/v2';

export const Container = styled(Row)`
	margin-top: 1rem;
`;

export const Label = styled.span`
	color: ${({ theme }) => theme.palette.secondary[300]};
	font-size: 0.875rem;
	line-height: 1rem;
`;

export const Total = styled.span`
	color: ${({ theme }) => theme.palette.secondary[300]};
	font-size: 0.875rem;
	line-height: 1rem;
`;

export const SelectWrapper = styled.div`
	.ant-select {
		width: 4rem;
	}

	.ant-select-selector {
		height: 2rem !important;
		border-color: ${({ theme }) => theme.palette.secondary[150]} !important;
		border-radius: 0.25rem !important;
	}

	.ant-select-selection-item {
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 0.875rem;
		line-height: 2rem;
	}

	.ant-select-arrow {
		width: 1rem;
		height: 1rem;
		margin-top: -0.5rem;
		color: ${({ theme }) => theme.palette.secondary[400]};
	}
`;

export const SelectArrow = styled(ArrowSlimIcon)`
	display: block;
	width: 1rem;
	height: 1rem;
`;

export const PreviousArrow = styled(ArrowSlimLeftIcon)`
	display: block;
	margin: 0.5rem auto;
	color: ${({ theme }) => theme.palette.secondary[150]};
`;

export const NextArrow = styled(ArrowSlimRightIcon)`
	display: block;
	margin: 0.5rem auto;
	color: ${({ theme }) => theme.palette.secondary[150]};
`;

export const PaginationStyled = styled(Pagination)`
	.ant-pagination-item,
	.ant-pagination-prev,
	.ant-pagination-next {
		min-width: 2rem;
		height: 2rem;
		margin: 0 0.125rem;
		line-height: 2rem;
		border: none;
		border-radius: 0.25rem;
	}

	.ant-pagination-item {
		background: ${({ theme }) => theme.palette.secondary[100]};

		a {
			color: ${({ theme }) => theme.palette.secondary[250]};
			font-size: 0.875rem;
			font-weight: 600;
		}
	}

	.ant-pagination-item-active {
		background: ${({ theme }) => theme.palette.primary[100]};

		a {
			color: ${({ theme }) => theme.palette.primary.default};
		}
	}
`;
